import { computed, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { StoreContext } from '../../../configuration/StoreContext';
import { IConfigurationComponentOrchestration } from '../../../models/app/IConfigurationComponentOrchestration';
import { IEntity, IExecutionOptions, IQueryOptions } from '../../../models/commonTypes';
import { QueryStore } from './QueryStore';
import { DocumentListStore } from './DocumentListStore';
import { IHeadingProps } from '@kurtosys/ksys-app-components/dist/components/base/Heading/models';

interface EntityStores {
    documentLists: DocumentListStore[];
}

export class EntityStore extends StoreBase {
    queryStore: QueryStore | undefined;
    constructor(storeContext: StoreContext, entityData?: IEntity) {
        super(storeContext);
        if (entityData) {
            const { queryStore, appStore } = this.storeContext;
            const newQueryStore = new QueryStore(storeContext);
            newQueryStore.context = {
                ...(queryStore.context || {}),
                entityByType: {
                    [entityData.type]: entityData,
                },
            };
            this.queryStore = newQueryStore;
            this.stores = {
                documentLists: appStore.getDocumentListStores(this),
            };
        }
    }

    async initialize() { }

    @observable stores: EntityStores = {
        documentLists: [],
    };

    @computed
    get headingProps(): IHeadingProps | undefined {
        const { entityGrouping } = this.storeContext.appStore;
        if (entityGrouping) {
            const { heading } = entityGrouping;
            if (heading) {
                return this.mergeQueriesAndProps(heading);
            }
        }
        return undefined;
    }

    getQueryValue(queryOptions?: IQueryOptions, responseForContext?: object, overrideExecutionOptions?: Partial<IExecutionOptions>) {
        return super.getQueryValue(queryOptions, responseForContext, overrideExecutionOptions, { queryStore: this.queryStore });
    }

    mergeQueriesAndProps<T>(componentOrchestration?: IConfigurationComponentOrchestration, responseContext?: any): T | undefined {
        return super.mergeQueriesAndProps(componentOrchestration, responseContext, { queryStore: this.queryStore });
    }

}